import {Component, Inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ApplicationMappingService, ApplicationService} from '../../../services';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {switchMap} from 'rxjs/operators';
import {from} from 'rxjs';
import {error} from 'protractor';

@Component({
  selector: 'app-further-advance-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule, MatProgressSpinnerModule, MatProgressBarModule],
  templateUrl: './further-advance-dialog.component.html',
  styleUrl: './further-advance-dialog.component.scss'
})
export class FurtherAdvanceDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<FurtherAdvanceDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public applicationService: ApplicationService,
              public applicationMappingService: ApplicationMappingService) {
  }

  ngOnInit() {
    if (this.data && this.data.appId && this.data.baseModel && this.data.furtherAdvanceApplicationType) {
      this.loadApplication(this.data.appId, this.data.baseModel, this.data.furtherAdvanceApplicationType, this.data.justiceApplication);
    }
  }

  loadApplication(appId, baseModel, furtherAdvanceApplicationType, justiceApplication = false) {
    console.log('generate from VX application');
    console.log('generate from VX application - justiceApplication', justiceApplication);
    this.applicationService.packetRetrieve(appId).pipe(
      switchMap((submissionModel: any) =>
        from(this.applicationMappingService.generateFormGroupModel(submissionModel, baseModel, appId, furtherAdvanceApplicationType, justiceApplication))
      ),
    ).subscribe({
      next: (formGroup: any) => {
        console.log('generated form group model', formGroup);
        this.dialogRef.close({
          success: true,
          data: formGroup,
        });
      },
      error: (err) => {
        console.log('Failed to load application packet', err);
        this.dialogRef.close({
          success: false,
          data: err,
        });
      }
    });
  }

  closeDialogEvent($event): void {
    this.dialogRef.close($event);
  }
}
